import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getSession } from "../../lib/api";

export function RequireAuth({ admin = false }: { admin?: boolean }) {
  const location = useLocation();
  const [state, setState] = useState<"loading" | "allowed" | "blocked">("loading");

  useEffect(() => {
    let active = true;
    const check = async () => {
      try {
        const session = await getSession();
        const allowed = admin
          ? session.user?.role === "kreatethedate_admin"
          : session.user?.role === "client" || session.user?.role === "viewer" || session.user?.role === "kreatethedate_admin";
        if (active) setState(allowed ? "allowed" : "blocked");
      } catch {
        if (active) setState("blocked");
      }
    };
    void check();
    return () => {
      active = false;
    };
  }, [admin]);

  if (state === "loading") {
    return (
      <div className="grid min-h-screen place-items-center bg-ktd-black text-white">
        <div className="luxe-card rounded-lg p-8 text-center">
          <p className="font-display text-3xl font-bold gold-text">Opening the vault</p>
          <p className="mt-3 text-sm text-white/62">Checking secure access...</p>
        </div>
      </div>
    );
  }

  if (state === "blocked") {
    return <Navigate to={admin ? "/admin/login" : "/login"} replace state={{ from: location }} />;
  }

  return <Outlet />;
}
